/**
 * Confetti effect on win. Skipped under prefers-reduced-motion (handled in
 * motion.css, but we also bail out at the JS level for safety).
 */

export function fireConfetti(): void {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const root = document.createElement('div');
  root.className = 'confetti';
  root.setAttribute('aria-hidden', 'true');
  for (let i = 0; i < 30; i++) {
    const p = document.createElement('span');
    p.className = 'confetti-particle';
    p.style.left = `${Math.random() * 100}%`;
    p.style.top = `${-Math.random() * 20}%`;
    p.style.animationDelay = `${Math.random() * 200}ms`;
    p.style.background = `var(--accent-${Math.random() > 0.5 ? '300' : '500'})`;
    root.appendChild(p);
  }
  document.body.appendChild(root);
  setTimeout(() => root.remove(), 1200);
}
